import "./Phlebotomy.scss";
import 'moment/locale/id';

import {Grow} from "@mui/material";
import {kfIconGroup} from "assets/images";
import FullScreenPage from "components/fullscreen";
import {Banner, Phlebotomy, RunningTextPhlebotomy} from "models/phlebotomy.model";
import {useEffect, useState} from "react";
import Marquee from "react-fast-marquee";
import Carousel from "react-material-ui-carousel";
import Moment from "react-moment";
import {connect} from "react-redux";
import QueueService from "services/queue.service";
import {ApplicationState} from "store";
import {ConfigState} from "store/config/config.reducer";


interface IStateProps {
    configState: ConfigState
}
const mapStateToProps = (state: ApplicationState): IStateProps => ({
    configState: state.configState
})
type Props = IStateProps;
const queueService = new QueueService();
interface PageQuery {
    page: number;
    size: number;
    totalPage: number;
}

let intervalFetchPhelbotomy: string | number | NodeJS.Timer | undefined;
function PhlebotomyPage({configState}: Props) {
    const [listPhelbotomy, setListPhlebotomy] = useState<Phlebotomy[]>([]);
    const [listBanner, setListBanner] = useState<Banner[]>([]);
    const [listRunningText, setListRunningText] = useState<RunningTextPhlebotomy[]>([]);

    const [pageQuery, setPageQuery] = useState<PageQuery>({page: 1, size: 8, totalPage: 0})
    const [startIndex, setStartIndex] = useState<number>(0)

    async function fetchData() {
        clearInterval(intervalFetchPhelbotomy);
        await queueService.getPhlebotomy(`${configState.outletId}`, pageQuery).then(
            ({data}) => {
                if (data?.result) {
                    setListPhlebotomy([]);
                    const list: any[] = data?.result || [];
                    setTimeout(() => {
                        setListPhlebotomy(list);
                    }, 300);
                    const totalPage = Number(data?.metaData?.pageCount || 0);
                    if (pageQuery.page !== 1) {
                        setStartIndex((pageQuery.page - 1) * pageQuery.size)
                    } else if (pageQuery.page === 1) {
                        setStartIndex(0);
                    }

                    if (pageQuery.page === totalPage) {
                        pageQuery.page = 1;
                        pageQuery.totalPage = 0;
                    } else {
                        pageQuery.page = pageQuery.page + 1;
                        pageQuery.totalPage = totalPage  
                    }
                    setPageQuery({...pageQuery});
                    intervalFetchPhelbotomy = setInterval(() => {
                        fetchData();
                    }, 15_000);
                }
            },
            error => {
                console.error('error fetch list phelbotomy', error)
            }
        )
    }

    async function fetchBanner() {
        await queueService.getBannerPhlebotomy(`${configState.outletId}`).then(
            ({data}) => {
                if (data?.result) {
                    setListBanner(data.result);
                }
            },
            error => console.error('error fetch banner phlebotomy', error)
        )
    }
    async function fetchRunningTextPhlebotomy() {
        await queueService.getRunningTextPhlebotomy(`${configState.outletId}`).then(
            ({data}) => {
                if (data?.result) {
                    setListRunningText(data.result);
                }
            },
            error => console.error('error fetch running text phlebotomy', error)
        )
    }
    const fetchAllData = async () => {
        fetchBanner();
        fetchRunningTextPhlebotomy();
        await fetchData();
    }
    
    useEffect(() => {
        fetchAllData();
        try {
            document.querySelector("#phlebotomy")?.requestFullscreen();
        } catch(error) {
            console.log("error fullscreen")
        }

        return () => {
            clearInterval(intervalFetchPhelbotomy);
        }
    }, []);

    return (
        <div id='phlebotomy'
            className='h-screen w-screen font-barlow bg-[#F9FAFF]' 
            style={{backgroundSize: 'cover'}}>
            <FullScreenPage pageId={"phlebotomy"} />
            <div className='flex flex-row h-full w-full' style={{gap: '2.5%'}}>
                <div className='flex flex-col h-full place-content-center w-[36%] ml-[4.7%]'>
                    <div className='flex justify-center h-[11%]'>
                        <img src={kfIconGroup} alt="" style={{marginTop: '2.3%', height: '75%'}}/>
                    </div>
                    <div className='bg-[#4A57CD] h-[89%]' 
                        style={{borderTopLeftRadius: '3rem', borderTopRightRadius: '3rem'}}>
                        <div className='date-sample-phlebotomy'>
                            <Moment locale="id" interval={1000} format="DD MMMM YYYY HH:mm"></Moment>
                        </div>
                        <Grow in={listPhelbotomy.length > 0}>
                        <div className="h-[89%] flex flex-col px-[5%] gap-[1.8%] list-sample overflow-hidden"
                            id="list-phlebotomy-patient">
                            {listPhelbotomy?.map((item, i) => 
                            <div className='h-[11%] rounded-[1.2rem] bg-[#E4E6F8] sample-item' key={item?.sampleId}>
                                <div className='text-[1.9rem] font-bold text-[#3A3A3C] w-[8%]'>
                                    <span className='mr-[3px]'>{(i + 1) + startIndex}.</span>
                                </div>
                                <div className='flex flex-col justify-between w-[98%]'>
                                    <div className='text-[1.9rem] font-bold text-[#3A3A3C]'>
                                        {item?.name}
                                    </div>
                                    <div className='flex flex-row justify-between'>
                                        <div className='text-[1.5rem] font-medium text-[#7E7E82]'>
                                            {item?.sampleId}
                                        </div>                                            
                                    </div>
                                </div>
                            </div>
                            )}
                        </div>
                        </Grow>
                    </div>
                </div>
                <div className='h-full w-[56.7%]'>
                    <div className='h-full flex flex-col justify-between'>
                        <div className='h-[10%] w-[93%]'>
                            <div className='h-full w-full flex items-center text-[2.8rem] font-bold'>
                            INFORMASI ANTRIAN PENGAMBILAN SAMPLE
                            </div>
                        </div>
                        <div className='h-[80.2%]'>
                           
                            <div className='w-[93%] rounded-[1.5rem]'>
                            <Carousel autoPlay={true} indicatorContainerProps={{className: "indicator-image-carousel"}}
                              className="image-carousel">
                                {
                                    listBanner?.map((item, i) => 
                                        <img className='rounded-[1.5rem]' src={item.image} alt="" key={item.ordered}/>
                                    )
                                }
                                
                            </Carousel>
                                
                            </div>
                        </div>
                        <div className='bg-[#003A78] w-full h-[7.3%] rounded-tl-3xl items-center
                            flex flex-row gap-6'>
                            <Marquee className="running-text" direction="left" 
                                speed={30} gradient={false}>
                                    {listRunningText?.map( (e,index) => 
                                        <div key={e.ordered}>
                                            {e?.text}
                                        </div>
                                    )}
                            </Marquee>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default connect(mapStateToProps)(PhlebotomyPage);